import React from "react";

export default function (props) {
  return (
    <svg
      version="1.1"
      viewBox="0 0 6.24 6.24"
      enableBackground="new 0 0 6.24 6.24"
    >
      <path
        fill={props.color}
        d="m0,.48v-0.48h6.24v0.48h-6.24zm0,1.92v-0.48h6.24v0.48h-6.24zm0,1.92v-0.48h6.24v0.48h-6.24zm0,1.92v-0.479h6.24v0.479h-6.24z"
      />
    </svg>
  );
}
